import CustomFields from "components/CustomFields"
import VueComponent from "../vue_component"

export default VueComponent(CustomFields)
